var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowRightIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.103 4.103C7.322 3.882 7.678 3.882 7.897 4.103L12.397 8.603C12.618 8.822 12.618 9.178 12.397 9.397L7.897 13.898C7.678 14.118 7.322 14.118 7.103 13.898C6.882 13.678 6.882 13.322 7.103 13.102L11.205 9L7.103 4.897C6.882 4.679 6.882 4.321 7.103 4.103Z",
    fill: "#030D45"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowRightIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrowRightIcon.842bd38d.svg";
export { ForwardRef as ReactComponent };